import { Grid, Menu, MenuItem, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MoreVert } from '@material-ui/icons';
import { Circle, CopyAll } from '@mui/icons-material';
import { withStyles } from '@material-ui/core/styles';
import { AddExamPopup } from './AddExamPopup';
import ReactDnD from '../common/ReactDnD';
import JourneyCard, { MenuItems } from '../common/JourneyCard';
import { showProgress } from '../../redux/actions/DealershipActions';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import service from '../../apis/service';
import EditIcon from '../../assets/SvgIonReorderTwo';
import PenIcon from '../../assets/PenIcon';
import EditIcon2 from '../../assets/EditIcon2';
import useSelectedCertInfo from './hooks/useSelectedCertInfo';

const Item = withStyles({
  root: {
    justifyContent: 'flex-start',
  },
})(MenuItem);

const useStyle = makeStyles({
  container: {
    marginLeft: '50px',
  },
  heading: {
    width: '97%',
    height: '50px',
    background: '#f3f4f7',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 10px',
  },

  questionCTA: {
    width: '100%',
    marginTop: '10px',
    marginBottom: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  linkText: {
    color: '#622FEE',
    fontWeight: '600',
    borderBottom: '2px solid #622FEE',
    cursor: 'pointer',
  },

  card: {
    background: '#f3f4f7',
    padding: '10px',
    width: '95%',
    borderRadius: '10px',
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  wrapper: {
    display: 'flex',
    gap: '10px',
    width: '95%',
  },
  content: {
    width: '100%',
  },
  title: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  equlaIcon: {
    fontSize: '18px',
  },
  img: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  qinfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    fontSize: '14px',
    color: '#667085',
    fontWeight: '500',
  },
});

export default function RightsideCert() {
  const classes = useStyle();
  const dispatch = useDispatch();
  const fetchSelectedCertInfo = useSelectedCertInfo();

  const selectedCertInfo = useSelector((state) => state.certificateData.selectedCertInfo);

  const [isOpenAddExam, setIsOpenAddExam] = useState(false);
  const [availableJourneys, setAvailableJourneys] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElExam, setAnchorElExam] = useState(null);
  const [examInfo, setExamInfo] = useState({});

  useEffect(() => {
    if (selectedCertInfo.id) {
      setAvailableJourneys(selectedCertInfo?.journeys || []);
    }
  }, [selectedCertInfo]);

  const handleUpdateJourney = async (journeyIds) => {
    dispatch(showProgress(true));
    try {
      await service.post(apiEndpoints.CERT_JOURNEYS_UPDATE.replace('ID', selectedCertInfo.id), {
        journeyIds,
      });
      notifySuccess('Jouney updated successfully');
      fetchSelectedCertInfo();
    } catch (error) {
      setAvailableJourneys(selectedCertInfo?.journeys || []);
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const handleDeleteJourney = () => {
    const temp = availableJourneys.filter((data) => data.id !== selectedId).map((data) => data.id);
    handleUpdateJourney(temp);
    setAnchorEl(null);
    setAnchorElExam(null);
  };

  useEffect(() => {
    if (selectedCertInfo?.id && selectedCertInfo?.exam) {
      setExamInfo(selectedCertInfo.exam || {});
    }
  }, [selectedCertInfo]);

  return (
    <Grid className={classes.container}>
      <Grid className={classes.heading}>
        <Typography variant="h6">Certification Content</Typography>
      </Grid>
      {!selectedCertInfo?.exam?.id && (
        <Grid className={classes.questionCTA}>
          <Typography className={classes.linkText} onClick={() => setIsOpenAddExam(true)}>
            + Add Exam
          </Typography>
        </Grid>
      )}
      <Grid>
        <ReactDnD
          data={availableJourneys}
          setData={setAvailableJourneys}
          setModifiedOrderIds={handleUpdateJourney}
          renderItem={(journeyData) => (
            <JourneyCard journeyData={journeyData} setSelectedId={setSelectedId} setAnchorEl={setAnchorEl} />
          )}
        />

        {selectedCertInfo?.exam?.id && (
          <div className={classes.card}>
            <p className={classes.equlaIcon}>
              <EditIcon />
            </p>
            <Grid className={classes.wrapper}>
              <Grid className={classes.img}>
                <PenIcon />
              </Grid>

              <Grid className={classes.content}>
                <Grid className={classes.title}>
                  <Typography>Final Exam</Typography>
                  <div>
                    <MoreVert onClick={(e) => setAnchorElExam(e.currentTarget)} style={{ cursor: 'pointer' }} />
                  </div>
                </Grid>
                <Typography variant="p" className={classes.qinfo}>
                  {examInfo.numberOfQuestions || 0} {(examInfo.numberOfQuestions || 0) > 1 ? 'Questions' : 'Question'}{' '}
                  <Circle style={{ fontSize: '10px' }} /> {examInfo.duration} mins
                </Typography>
              </Grid>
            </Grid>
          </div>
        )}

        <MenuItems anchorEl={anchorEl} setAnchorEl={setAnchorEl} onDelete={handleDeleteJourney} />
        <Menu
          id="simple-menu"
          anchorEl={anchorElExam}
          keepMounted
          open={Boolean(anchorElExam)}
          onClose={() => setAnchorElExam(null)}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <Item
            style={{ display: 'flex', gap: '10px' }}
            onClick={() => {
              setIsOpenAddExam(true);
              setAnchorElExam(null);
            }}
          >
            <EditIcon2 /> Edit Exam
          </Item>
          <Item
            style={{ display: 'flex', gap: '10px' }}
            onClick={() => {
              navigator.clipboard.writeText(examInfo.certificateShareDeepLink);
              notifySuccess('Certification Deeplink Copied');
            }}
          >
            <CopyAll /> Copy Certificate Share Deep Link
          </Item>
        </Menu>
      </Grid>

      {isOpenAddExam && (
        <AddExamPopup
          isEdit={selectedCertInfo?.exam?.id}
          isOpenAddExam={isOpenAddExam}
          setIsOpenAddExam={setIsOpenAddExam}
        />
      )}
    </Grid>
  );
}
